<div [ngClass]="{'tools-menu--opened': menuOpened}">
  <div class="tools-menu__container" [class.disabled]="ContextData.MODE == CanvasEvent.SET_CROP_MODE">
    <div class="tools-menu__toggle menu-toggle" (click)="toggleMenu(); accordion.closeAll()" [ngClass]="{'menu-toggle--opened': menuOpened}">
      <span class="menu-toggle__line"></span>
      <span class="menu-toggle__line"></span>
      <span class="menu-toggle__line"></span>
    </div>
    
    <div class="tools-menu__content">

      <div class="tools-menu__title" [innerHtml]="'cfg_title' | translate"></div>

      <accordion (onOpen)="menuOpened = true"  #accordion>
        <accordion-item title="{{ 'cfg_colorPanel_title' | translate }}" icon="icon-paint-board-and-brush">
          <color-panel [label]="label" [layer]="layerData"></color-panel>
        </accordion-item>
        <accordion-item title="{{ 'cfg_textPanel_title' | translate }}" icon="icon-font">
          <text-panel [label]="label" [layer]="layerData"></text-panel>
        </accordion-item>
        <accordion-item title="{{ 'cfg_imagePanel_title' | translate }}" icon="icon-photo-camera">
          <image-panel [label]="label" [layer]="layerData"></image-panel>
        </accordion-item>
        <accordion-item title="{{ 'cfg_layerPanel_title' | translate }}" icon="icon-repeat">
          <layers-panel [label]="label" [layer]="layerData"></layers-panel>
        </accordion-item>
        <accordion-item title="{{ 'cfg_shapePanel_title' | translate }}" icon="icon-divide">
          <shape-panel [label]="label" [layer]="layerData"></shape-panel>
        </accordion-item>
        <accordion-item [class.disabled]="applicationData.configuration.mode == CONFIGURATION_MODE.EXCEL" title="{{ 'cfg_savePanel_title' | translate }}" icon="icon-save">
          <save-panel></save-panel>
        </accordion-item>
        <accordion-item [class.disabled]="applicationData.configuration.mode == CONFIGURATION_MODE.EXCEL" title="{{ 'cfg_printPanel_title' | translate }}" icon="icon-printer-tool">
          <print-panel></print-panel>
        </accordion-item>
        <accordion-item [class.disabled]="applicationData.configuration.mode != CONFIGURATION_MODE.EXCEL" title="{{ 'cfg_excelPanel_title' | translate }}" icon="icon-csv-file-format-extension">
          <excel-panel [label]="label" *ngIf="applicationData.configuration.mode == CONFIGURATION_MODE.EXCEL"></excel-panel>
        </accordion-item>
      </accordion>
    </div>
  </div>
</div>
